module.exports = __webpack_public_path__ + "static/media/landing-page-preview.628cdefc.png";